// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wa-skeleton {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef0f4 25%, #f7f8fa 37%, #eef0f4 63%);
  background-size: 400% 100%;
  animation: wa-skeleton-shimmer 1.4s ease infinite;
}

@keyframes wa-skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wa-skeleton {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/app/wa-cost-monitoring/waCostMonitoring.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".wa-skeleton {\n  display: block;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #eef0f4 25%, #f7f8fa 37%, #eef0f4 63%);\n  background-size: 400% 100%;\n  animation: wa-skeleton-shimmer 1.4s ease infinite;\n}\n\n@keyframes wa-skeleton-shimmer {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wa-skeleton {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
